/**
 * 칭호·캐릭터 슬롯 수치. 소스는 `titles.json`.
 */

import seed from './titles.json';
import { emitDataReloadSoon, replaceArray, replaceRecord, requireRecord } from './catalog';

export type TitleUnlock =
  | { kind: 'start' }
  | { kind: 'level'; level: number }
  | { kind: 'kills'; monsterId: string; count: number }
  | { kind: 'quest'; questId: string };

export interface TitleDef {
  id: string;
  name: string;
  color: string;
  hint: string;
  unlock: TitleUnlock;
}

export let ROSTER = { ...seed.ROSTER };
export let DEFAULT_TITLE = seed.DEFAULT_TITLE;
export const TITLE_ORDER: string[] = [...seed.TITLE_ORDER];
export const TITLES: Record<string, TitleDef> = structuredClone(seed.TITLES) as Record<string, TitleDef>;

export function getTitle(id: string | undefined): TitleDef {
  return TITLES[id ?? DEFAULT_TITLE] ?? TITLES[DEFAULT_TITLE];
}

export function isTitleEarned(
  def: TitleDef,
  ctx: { level: number; kills: Record<string, number>; quests: Record<string, { status: string }> },
): boolean {
  const u = def.unlock;
  if (u.kind === 'start') return true;
  if (u.kind === 'level') return ctx.level >= u.level;
  if (u.kind === 'kills') return (ctx.kills[u.monsterId] ?? 0) >= u.count;
  return ctx.quests[u.questId]?.status === 'done';
}

export function applyTitles(raw: unknown): void {
  const data = requireRecord(raw, 'titles.json');
  const roster = requireRecord(data.ROSTER, 'ROSTER');
  ROSTER = {
    maxSlots: Number(roster.maxSlots) || 6,
    nameMin: Number(roster.nameMin) || 2,
    nameMax: Number(roster.nameMax) || 8,
  };
  if (typeof data.DEFAULT_TITLE === 'string') DEFAULT_TITLE = data.DEFAULT_TITLE;
  if (Array.isArray(data.TITLE_ORDER)) replaceArray(TITLE_ORDER, data.TITLE_ORDER as string[]);
  replaceRecord(TITLES, structuredClone(requireRecord(data.TITLES, 'TITLES')) as Record<string, TitleDef>);
}

if (import.meta.hot) {
  import.meta.hot.accept('./titles.json', (mod) => {
    if (!mod?.default) return;
    applyTitles(mod.default);
    emitDataReloadSoon();
  });
}
